var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3H19V5H5V3ZM5 19H3V5H5V19ZM19 19V21H5V19H19ZM19 19H21V5H19V19ZM10 8H8V10H10V8ZM14 8H16V10H14V8ZM9 14V12H7V14H9ZM15 14V16H9V14H15ZM15 14H17V12H15V14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyM);
export default __webpack_public_path__ + "static/media/happy-m.e6f404b36d230d27e4405ec2b3426eba.svg";
export { ForwardRef as ReactComponent };